<script setup>

import {computed, getCurrentInstance, inject, onMounted, ref, shallowRef} from "vue";

const emits = defineEmits(['close']);
const props = defineProps({
    id: {
        type: String,
        require: true,
    },
    title: {
        type: String,
    },
    body: {
        type: String,
    },
    show: {
        type: Boolean,
        default: false
    },
    hideWrap: {
        type: Boolean,
        default: false
    },
    canClose: {
        type: Boolean,
        default: true
    }
});
const opened = ref(props.show);
const arcticModal = inject('arcticModal', undefined);
const self = getCurrentInstance();
const componentToShow = shallowRef(null);
const componentToShowParams = shallowRef(null);
const componentModalParams = shallowRef({});

onMounted(() => {
    if (arcticModal !== undefined) {
        arcticModal[props.id] = self;
    } else {
        if (self.appContext.app.config.globalProperties.$arcticModal === undefined) {
            self.appContext.app.config.globalProperties.$arcticModal = {};
        }
        self.appContext.app.config.globalProperties.$arcticModal[props.id] = self;
    }
});

const open = () => {
    opened.value = true;
};
const close = () => {

    opened.value = false;
    emits('close');
};
const hideModal = (event) => {
    if (!props.canClose)
        return;
    if (!event.target.checkVisibility()) {
        return;
    }
    if ((!event.target.classList.contains('arcticmodal-container_i2')
            && !event.target.closest('.arcticmodal-container_i2'))
        || event.target.classList.contains('popup__close')) {
        console.log((!event.target.classList.contains('arcticmodal-container_i2')
            && !event.target.closest('.arcticmodal-container_i2')));
        console.log(event.target.classList.contains('popup__close'));
        close();
    }
};
const show = (component, params, modalParams) => {
    componentToShow.value = component;
    componentToShowParams.value = params;
    opened.value = true;
    if (modalParams) {
        componentModalParams.value = modalParams;
    }
};

const inlineStyles = computed(() => {
    let result = '';
    for (let k in componentModalParams.value) {
        switch (k) {
            case 'width':
                result += 'width:' + componentModalParams.value[k];
                result += Number.isInteger(componentModalParams.value[k]) ? 'px;' : ';';
            break;
            case 'height':
                result += 'height:' + componentModalParams.value[k];
                result += Number.isInteger(componentModalParams.value[k]) ? 'px;' : ';';
            break;

        }
    }
    return result;
})

defineExpose({
    open,
    close,
    show
});


</script>
<template>
    <div v-show="opened">
        <div class="arcticmodal-overlay" style="background-color: rgb(0, 0, 0); opacity: 0.6;"></div>
        <div @click="hideModal" class="arcticmodal-container" :id="id">
            <table class="arcticmodal-container_i">
                <tbody>
                <tr>
                    <td class="arcticmodal-container_i2">
                        <component
                            v-if="componentToShow"
                            :style="inlineStyles"
                            :is="componentToShow"
                            v-bind="componentToShowParams"
                            @close="close"
                        ></component>
                        <div v-else-if="!hideWrap" class="popup adm__popup" style="min-width: 320px" :style="inlineStyles">
                            <i class="popup__close arcticmodal-close"></i>
                            <div class="adm__popup-title">{{title}}</div>
                            <div v-if="body" class="adm__popup-text">
                                {{body}}
                            </div>
                            <slot></slot>
                        </div>
                        <slot v-else></slot>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ArcticModal',
};
</script>
<style>
@import "../../../design_kit/libs/arcticmodal/jquery.arcticmodal-0.3.css";
@import "../../../design_kit/site/blocks/popup/style.scss";
[id^=hint] .popup {
  max-width: 760px;
}
</style>
